import React, { useEffect, useState } from "react";
import { Button, ControlLabel, FormGroup, ListGroupItem } from "react-bootstrap";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import clone from "lodash.clonedeep";
import * as FilesApi from "../../../../../api/cp/episodeFile";
import { Event } from "../../../Comet";
import EpisodeFile from "../components/EpisodeFile";
import MaterialsUpdateModal from "../EditModals/MaterialsUpdateModal";

const Materials = ({ episode }) => {
    const [files, setFiles] = useState([]);
    const [editableMaterial, setEditableMaterial] = useState(null);
    const [isMaterialsModalVisible, setMaterialsModalVisible] = useState(false);

    useEffect(() => {
        setFiles(episode.files.sort((a, b) => (a.sortOrder - b.sortOrder)) ?? []);
    }, []);

    const handleFileCreate = async (file) => {
        try {
            const response = await FilesApi.createEpisodeFile(episode.id, file);
            setFiles((prevState) => [...prevState, response]);
        } catch (error) {
            console.error(error);
        }
    };

    const handleFileUpdate = async (updatedFile) => {
        try {
            await FilesApi.updateEpisodeFile(updatedFile.id, updatedFile);
        } catch (error) {
            console.error(error);
        }
    };

    const handleFileDelete = async (id) => {
        try {
            await FilesApi.deleteEpisodeFile(id);
            setFiles(files.filter((file) => file.id !== id));
        } catch (error) {
            console.error(error);
        }
    };

    const handleEditFile = (file) => {
        setEditableMaterial(file);
        setMaterialsModalVisible(true);
    }

    const updateFilesList = async (list) => {
        try {
            setFiles(list);
            const payload = list.map(({id}) => id);
            await FilesApi.updateEpisodeFilesOrder(episode.id, payload);
        } catch (error) {
            console.error(error);
        }
    };

    function onDragEnd(result) {
        if (!result.destination) {
            return;
        }

        const reorderedFiles = reorder(
            files,
            result.source.index,
            result.destination.index,
        );

        updateFilesList(reorderedFiles);
    };

    function reorder(list, startIndex, endIndex) {
        const result = clone(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    }

    const handleCometEpisodeUpdate = (episode) => {
        setFiles(episode.files);
    };

    return (
        <section style={{marginTop: '12px'}}>
            <Event event="update:episode" handler={handleCometEpisodeUpdate} />
            <FormGroup>
                <ControlLabel>Материалы</ControlLabel>
                <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="droppable">
                        {(provided) => (
                            <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                            >
                                {files?.map((file, index) => (
                                    <Draggable
                                        key={file.id}
                                        draggableId={`${file.id || index}`}
                                        index={index}
                                    >
                                        {(provided) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                style={
                                                    provided.draggableProps.style
                                                }
                                            >
                                                <ListGroupItem>
                                                    <EpisodeFile
                                                        file={file}
                                                        onUpdate={handleEditFile}
                                                        onDelete={handleFileDelete}
                                                    />
                                                </ListGroupItem>
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
                <Button
                    style={{marginTop: '12px'}}
                    onClick={() => setMaterialsModalVisible(true)}
                >
                    Добавить материалы
                </Button>
            </FormGroup>

            <MaterialsUpdateModal
                show={isMaterialsModalVisible}
                editableMaterial={editableMaterial}
                onUpdate={handleFileUpdate}
                onSave={handleFileCreate}
                onClose={() => setMaterialsModalVisible(false)}
            />
        </section>
    );
};

export default Materials;
